export default __webpack_public_path__ + "static/media/shopping-cart-1.050afa57.png";